/* tslint:disable */
/* eslint-disable */
/* @relayHash c1cdddae5255244b79d71f94d3721841 */

import { ConcreteRequest } from "relay-runtime";
export type recaptchaFeatureFlagQueryVariables = {
    featureFlag: string;
};
export type recaptchaFeatureFlagQueryResponse = {
    readonly viewer: {
        readonly featureFlag: boolean | null;
    };
};
export type recaptchaFeatureFlagQuery = {
    readonly response: recaptchaFeatureFlagQueryResponse;
    readonly variables: recaptchaFeatureFlagQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "featureFlag",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "featureFlag",
  "args": [
    {
      "kind": "Variable",
      "name": "feature",
      "variableName": "featureFlag"
    }
  ],
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "recaptchaFeatureFlagQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "recaptchaFeatureFlagQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "recaptchaFeatureFlagQuery",
    "id": "ferrum/289.0.0-2020-11-03T20:56:25.991Z/recaptchaFeatureFlagQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '7c4bbcedade62a494e9f69ea3c95526d';
export default node;
